/**
 * SiteFooter.jsx
 *
 * Mech-HUD styled footer with social links and copyright line.
 */

import React from 'react';
import { logo } from '../assets/images';
import GlowText from './GlowText';
import Panel from './Panel';

const SOCIALS = [
  {
    label:  'X',
    handle: '@HexaBots_',
    href:   'https://x.com/HexaBots_',
    Icon: () => (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
        <path d="M18.244 2H21l-6.52 7.45L22.5 22h-6.83l-4.77-6.24L5.2 22H2.44l6.98-7.97L1.5 2h6.98l4.32 5.72L18.244 2Zm-1.19 18h1.71L7.05 4H5.24l11.82 16Z" />
      </svg>
    ),
  },
  {
    label:  'TELEGRAM',
    handle: 't.me/HEXABOTSOFFICIALS',
    href:   'https://t.me/HEXABOTSOFFICIALS',
    Icon: () => (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
        <path d="M21.94 4.6c.27-1.18-.94-2.13-2.02-1.68L2.4 10.13c-1.25.5-1.24 2.26.02 2.74l4.4 1.68 1.7 5.44c.2.63 1 .82 1.47.35l2.4-2.38 4.36 3.24c.98.72 2.38.19 2.65-1L21.94 4.6ZM8.6 13.6l9.5-6.72c.34-.24.7.2.4.48l-7.9 7.35c-.3.28-.5.66-.56 1.07l-.28 1.9-1.16-4.08Z" />
      </svg>
    ),
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-10">
      <Panel title="COMMS // JOIN THE NETWORK">
        <div className="flex flex-col items-center gap-6 text-center">
          <div
            className="w-14 h-14 flex items-center justify-center overflow-hidden float-anim"
            style={{
              border: '1px solid var(--cyan)',
              clipPath: 'polygon(10px 0, 100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%, 0 10px)',
              boxShadow: '0 0 16px rgba(0,229,255,0.45)',
            }}
          >
            <img src={logo} alt="HEXABOTS" className="w-full h-full object-cover" />
          </div>

          <GlowText as="div" text="JOIN THE SIGNAL" size={18} variant="cyan" />

          <div className="flex flex-wrap items-center justify-center gap-3">
            {SOCIALS.map(({ label, handle, href, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-robotic btn-robotic-cyan flex items-center gap-3 px-4 py-3 no-underline"
              >
                <span
                  className="flex items-center justify-center w-8 h-8"
                  style={{ border: '1px solid var(--steel-light)', borderRadius: 4 }}
                >
                  <Icon />
                </span>
                <span className="text-left normal-case tracking-normal font-normal" style={{ fontFamily: "'Rajdhani', sans-serif" }}>
                  <span className="block font-bold" style={{ fontFamily: "'Orbitron', sans-serif", fontSize: 11 }}>{label}</span>
                  <span className="block mt-0.5 text-dim" style={{ fontSize: 12 }}>{handle}</span>
                </span>
              </a>
            ))}
          </div>

          <div className="w-full pt-4" style={{ borderTop: '1px solid var(--steel)' }}>
            <span className="font-mono-hud text-dim" style={{ fontSize: 12, letterSpacing: '0.08em' }}>
              (C) HEXABOTS // ALL SIGNALS RESERVED
            </span>
          </div>
        </div>
      </Panel>
    </footer>
  );
}
